module.exports = __webpack_public_path__ + "img/password-default.072a3277.svg";